import $ from 'jquery'

$('.js-team-review-block-play').on('click', () => {
    $('body').addClass('team-video-active video-active')

    const videoBlock = $('.team-review-block__video')
    const videoWrapper = $('.team-review-block__video-wrapper')
    if (
        !videoWrapper.hasClass('team-review-block__video-wrapper--loaded') &&
        videoWrapper.hasClass('team-review-block__video-wrapper--youtube')
    ) {
        videoWrapper.append(`<iframe src="${videoWrapper.attr('data-src')}">`)
        videoWrapper.addClass('team-review-block__video-wrapper--loaded')
    }
    videoBlock.addClass('video-active')
})
